<template>
<div class="chapter">
<div class="inner_page">
<p class="vh1"><span class="small">SONG OF THE ROAD</span></p><p class="vtx">The dust took my land and nothing grew</p><p class="vtx">I took off with my brood. Was all I could do.</p><p class="vtx">On Route 66, some folks was kind.</p><p class="vtx3">Andy Connors is one who comes to my mind.</p><p class="vtx1">At his garage he gassed up my heap,</p><p class="vtx">Gave me 'n my family somewheres to sleep.</p><p class="vtx">Then that rabid skunk give him such a bite!</p><p class="vtx3">He needed them shots that could fix him up right.</p><p class="vtx1">A stranger drove in and took him to get 'em,</p><p class="vtx">Then took over the place. Guess Andy let him.</p><p class="vtx">Stranger tended the store, daughters and farm</p><p class="vtx3">And the woman who lived there; kept 'em from harm.</p><p class="vtx1">Quite a story begun there, something to tell.</p><p class="vtx">You can read all about it if you set fer a spell.</p><p class="vtx">Me—I'm off in the mornin', me and my kin,</p><p class="vtx3">On Route 66 where big dreams begin.</p><p class="vtx1">Mother Road, take me west.</p><p class="vtx">Lead the way to where the chances are best.</p><p class="vtx">Rough or smooth, paved or gravel,</p><p class="vtx">You're the pathway to hope that I'm aimin' to travel.</p><p class="eps1">—F.S.I</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MotherRoad_epig-1.vue?9166b90c